export default __webpack_public_path__ + "static/media/TimeClockFileWhite.0da00bd1.svg";